// --------------------------------------------------------------------------
// helper functions for the looking up scanned wine data
// --------------------------------------------------------------------------

import { restGET } from '../../helpers/rest.js';

// --------------------------------------------------------------------------

// singleton cache of mapping data
let mappings = null;

// --------------------------------------------------------------------------
// helper functions to return 'structured' data, without overhead of a class
// --------------------------------------------------------------------------

function successResponse(wines) {
    return {
        state   : 'success',
        error   : false,
        wines   : wines
    }
}

// --------------------------------------------------------------------------

function errorReponse(state) {
    return {
        state   : state,
        error   : true,
        wines   : []
    }
}

// --------------------------------------------------------------------------

export async function getWineDataByBarCode(barcodeToTest, mappingDataURL, APIURLprefix , isContentfulData=false) {

    console.log(barcodeToTest);
    // This API is going to change; so lets standardise our response now
    // Also, the current API call returns a single result
    // whereas the new API will return multiple results so so shall we
    
    //const mappingDataURL = 'https://dw-bs-uat.web.app/data/ean-mapping.json';
    //const mappingDataURL = 'https://www.laithwaites.co.uk/json/barcode/barcodemap.json';
    if(isContentfulData){
        mappings=isContentfulData;
    }
    
    if(mappings==null) {
        let mappingData = null;
        try {
            mappingData = await restGET(mappingDataURL);
        } catch {
            // do nothing 
        }
        if(mappingData!=null) mappings = await mappingData.json().catch( e=> null ); // can safely  assume it is valid
    }

    if(mappings==null) { return errorReponse('noInternet'); }

    let productIds = mappings[barcodeToTest];

    // could not map to individual barcodes - so return an error
    if(productIds==null) { return errorReponse('noSuchProduct'); }

    let wines = [];

    // let's fake the API result as per Leighton's email 22/04/2020 12:44
    // first the overall wrapper for a successful call
    let apiResponse = {
        response : {
            statusMessage   : 'successful', // why?
            statusCode      : 0, // why?
            products        : []
        },
        statusMessage   : 'successful',
        statusCode      : 0,
    };

    // now populate the products object with the real response per individual product api call
    // if ANY individual product call fails, the whole thing needs to fail
    for(let i=0; i<productIds.length && apiResponse!=null; i++) {

        let mappedId = productIds[i];
        console.log(mappedId);
        
        let url = `${APIURLprefix}/api/product/item/${mappedId}`;

        let response = await restGET(url).catch( e => null ); // handle network error

        if(response==null) { return errorReponse('noInternet'); }

        let data = response==null ? null : await response.json().catch( e => null ); // handle json not being readable
        
        if(data==null) { return errorReponse('badData'); }

        let ok = data.statusCode==0 ? true : false; // handle it working the way we want

        // one call fails, all calls fail
        if(ok) {
            apiResponse.response.products.push(data.response);
        } else {
            apiResponse.statusCode = data.statusCode;
            apiResponse.statusMessage = data.statusMessage;
        }
    }

    // the above code will be scrapped once the real API is created;
    // but now it looks like the real result API result

    if(apiResponse==null || apiResponse.statusCode!=0 || apiResponse.response==null || apiResponse.response.products==null) {
        
        return errorReponse('noSuchProduct');

    }

    let listOfProducts = apiResponse.response.products;
    
    for(let i=0; i<listOfProducts.length; i++) {

        let productData = listOfProducts[i];
                
        let productId = productData.itemCode;
    
        wines.push( {
            productId       : productId,
            name            : productData.name,
            vintage         : productData.vintage,
            thumbnailImage  : productData.thumbnailImage
        } );
    
    };
    
    // excellent - return a response with all wine data we wish to expose, in the form we wish to expose it
    return successResponse(wines);
    
}

// --------------------------------------------------------------------------
